import React from 'react'
import Carousel from 'react-material-ui-carousel'
import banner_img1 from '../images/banner/1.png'
import banner_img2 from '../images/banner/2.png'


export default function Banner() {

    const data = [
        banner_img1,
        banner_img2,
    ]

    return (
        <>
            <Carousel
                className="carasousel"
                autoPlay={true}
                animation="slide"
                indicators={false}
                navButtonsAlwaysVisible={true}
                cycleNavigation={true}
                navButtonsProps={{
                    style: {
                        background: "#7b7b7b29",
                        color: "#494949",
                        borderRadius: '50%',
                        marginTop: -22,
                    }
                }}>
                {
                    data.map((imag, i) => {
                        return (
                            <>
                                <img src={imag} alt="img" key={i} className="banner_img" />
                            </>
                        )
                    })
                }

            </Carousel>
        </>
    )
}
